// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './style/reset.css'
import './style/nomalize.less'
import axios from 'axios'
import Cookie from 'js-cookie'
import store from './store/store'
import './router/http.js'
import '../src/style/font_3438627_nnlmxuxj9bf/iconfont.css'
// import VideoPlayer from 'vue-video-player'
// import VueQuillEditor  from 'vue-quill-editor'

// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')

// Vue.use(VideoPlayer)
// Vue.use(VueQuillEditor)

Vue.use(ElementUI)

Vue.prototype.Axios = axios
Vue.prototype.Cookie = Cookie

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js